import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeftDouble20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.0303 4.53033L9.9696 3.46967L3.43927 10L9.9696 16.5303L11.0303 15.4697L5.56059 10L11.0303 4.53033Z'
      fill='currentColor'
    />
    <path
      d='M16.5303 4.53033L15.4696 3.46967L8.93927 10L15.4696 16.5303L16.5303 15.4697L11.0606 10L16.5303 4.53033Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeftDouble20.displayName = 'ChevronLeftDouble20';
export default ChevronLeftDouble20;
